module.exports = __webpack_public_path__ + "img/img_cx2.e6d23cba.jpg";